import { graphql } from 'gatsby';
import { Container } from "../../../../src/blocks";
import SEO from "../../../../src/components/seo";
import * as React from 'react';
export default {
  graphql,
  Container,
  SEO,
  React
};